import React from 'react'
import SalesData from './SalesData';
// import ManagerData from './ManagerData';

const FinanceData = ({ handlerefresh,
    filteredQuotation,
    selectedProject,
    projects,
    calculatedProjects,
    tasks,
    items,
    formatOtherExpense,
    formatTotalExpense,
    useProjectAssignedRates = false }) => {    
    return (
        <div className='pt-5'>
            <div className="w-full relative pt-4  px-2 flex  align-middle items-center rounded-md">
                <div>
                    <h1 className="text-xl font-semibold capitalize">{selectedProject.ProjectName}</h1>
                </div>
            </div>

                <div>
                    <SalesData
                        filteredQuotation={filteredQuotation}
                        selectedProject={selectedProject}
                        projects={projects}
                        calculatedProjects={calculatedProjects}
                        tasks={tasks}
                        items={items}
                        formatOtherExpense={formatOtherExpense}
                        formatTotalExpense={formatTotalExpense}
                        useProjectAssignedRates={useProjectAssignedRates}
                    />
                </div>
        </div>
    )
}

export default FinanceData